module.exports = __webpack_public_path__ + "img/baoche.9a008749.png";